import React, {useEffect} from 'react';
import {LoadingConnected, SearchWidget} from './components';
import {init} from "./store/reducers/app";
import {useDispatch} from "react-redux";

function App() {

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(init());
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <LoadingConnected/>
            <SearchWidget/>
        </>
    );
}

export default App;
